import { gql, useQuery } from '@apollo/client';

import { ListingFilter, ListingSort } from '__generated__/globalTypes';

import {
  GetMarketplaceListings,
  GetMarketplaceListingsVariables,
  GetMarketplaceListings_listings,
} from './__generated__/GetMarketplaceListings';
import { RequestAccessFragments } from './RequestAccess.fragments';

export const MarketplaceDatatableFragments = {
  entry: gql`
    fragment MarketplaceDatatableListing on PublicListing {
      id
      name
      asset_class
      loan_count
      t_current_balance_cents
      top_states
      wa_borrower_credit_score
      wa_coupon_bps
      wa_current_balance_cents
      wa_dti_bps
      wa_loan_age_months
      wa_remaining_loan_terms_months
      wa_ltv_bps
      in_progress_deal_id
      company {
        __typename
      }
      ...RequestAccessPublicListing
    }
    ${RequestAccessFragments.PublicListing}
  `,
  company: gql`
    fragment MarketplaceDatatableCompany on Company {
      type
    }
  `,
};
const query = gql`
  query GetMarketplaceListings(
    $sort: ListingSort!
    $filters: [ListingFilter!]
    $pagination: Pagination
  ) {
    listings(sort: $sort, filters: $filters, pagination: $pagination) {
      id
      last_updated_date
      ...MarketplaceDatatableListing
    }
  }
  ${MarketplaceDatatableFragments.entry}
`;

const EMPTY_ARR: GetMarketplaceListings_listings[] = [];

export function useMarketPlaceListings_gql(filters?: ListingFilter[], sort?: ListingSort) {
  const { loading, data, previousData } = useQuery<
    GetMarketplaceListings,
    GetMarketplaceListingsVariables
  >(query, {
    variables: {
      pagination: { offset: 0, page_size: 100 },
      filters: filters || [],
      sort: sort || {},
    },
    fetchPolicy: 'cache-and-network',
  });

  const listings = data?.listings || previousData?.listings || EMPTY_ARR;

  return { listings, loading };
}
